// TODO: Split HTML elements and CSS display properties to separate enums/union types
export enum ContainerType {
    GRID = 'grid',
    FLEX = 'flex',
    BLOCK = 'block',
    INLINE_BLOCK = 'inline-block',
    FOOTER = 'footer',
    SECTION = 'section',
    NAV = 'nav',
    ARTICLE = 'article',
    HEADER = 'header',
    DIV = 'div',
}
